import type { ReactNode } from 'react';
import { Box, Card, Flex, Text } from '@mantine/core';

type Props = {
  title: string;
  description?: string;
  headerRight?: ReactNode;
  children?: ReactNode;
};

export const OrganisationViewCardSection = ({
  title,
  description,
  headerRight,
  children,
}: Props) => {
  return (
    <Card
      sx={theme => ({
        border: `1px solid ${theme.colors.gray[1]}`,
        boxShadow: 'none',
      })}
    >
      <Card.Section
        sx={theme => ({
          borderBottom: `1px solid ${theme.colors.gray[1]}`,
          padding: theme.other.spacing(2.5, 3),
        })}
      >
        <Flex justify="space-between" align="center" gap="xl">
          <Box>
            <Text sx={{ fontSize: 15, fontWeight: 'bold' }}>{title}</Text>
            {description && (
              <Text
                sx={theme => ({
                  fontSize: 13,
                  color: theme.colors.gray[6],
                  marginTop: theme.other.spacing(1),
                })}
              >
                {description}
              </Text>
            )}
          </Box>
          {headerRight}
        </Flex>
      </Card.Section>
      {children && (
        <Card.Section sx={theme => ({ padding: theme.other.spacing(3) })}>
          {children}
        </Card.Section>
      )}
    </Card>
  );
};
